import React from 'react';
import SelectorIdiomaCV from './controladorVista/selectorIdiomaCV';

const SelectorIdioma: React.FunctionComponent = () => <SelectorIdiomaCV />;

export default SelectorIdioma;
